export default __webpack_public_path__ + "static/media/Banner-brasilia.6ac57611.jpeg";